// store/balance/balanceInitialState.ts

import { FilterType } from '../../components/Transactions/FiltersDivers/TagRendering/TagMapping';
import { GrandLivreInfos, Transaction } from '../../types';

/**
 * @french
 * Initialise les filtres sauvegardés avec des valeurs par défaut.
 */
const getInitialSavedFilters = (): Map<FilterType, any> => {
  //return this if there is no stored saved filters
  const initialFilters = new Map();
  initialFilters.set(FilterType.TOUTES_LIGNES, true);
  initialFilters.set(FilterType.LIGNES_LETTRES, false);
  initialFilters.set(FilterType.LIGNES_NON_LETTRES_PLUS_LETTRAGE_PARTIEL, false);
  initialFilters.set(FilterType.LETTRAGE_PARTIEL, false);
  initialFilters.set(FilterType.LIGNES_VUES, false);
  initialFilters.set(FilterType.LIGNES_NON_VUES, false);
  initialFilters.set(FilterType.LIGNES_LETTRES_NON_VALIDEES, false);
  initialFilters.set(FilterType.LIGNES_VALIDEES, false);
  initialFilters.set(FilterType.LIGNES_NON_VALIDEES, false);
  initialFilters.set(FilterType.LIGNES_TAGUEES, false);
  initialFilters.set(FilterType.LIGNES_NON_TAGUEES, false);
  initialFilters.set(FilterType.COMPTABILITE_STANDARD_JOURNAL, true);
  initialFilters.set(FilterType.COMPTABILITE_ANALYTIQUE_JOURNAL, false);
  initialFilters.set(FilterType.COMPTABILITE_STANDARD_GRAND_LIVRE, true);
  initialFilters.set(FilterType.COMPTABILITE_ANALYTIQUE_GRAND_LIVRE, false);
  return initialFilters;
};

/**
 * @french
 * État initial du slice de balance.
 */
export const transactionsInitialState = {
  grandLivreDataSource: [] as GrandLivreInfos[],
  selectedTransactions: [] as Transaction[],
  isTransactionsLoading: false,
  selectedValues: [] as FilterType[],
  isEcritureHistoryModalOpen: false,
  clickedEcritureId: null as string | null,
  savedFilters: getInitialSavedFilters(),
  filtredTransactions: [] as Transaction[],
  secondarySelectedTransactions: [] as Transaction[],
  isSecondaryTransactionsLoading: false,
  isLettrerModalVisible: false,
  isListTransactionsParCompteEmpty: false,
  relatedEcrituresCount: 0,
  uniquePieceIdsCount: 0,
  isAddTagToTransactionModalVisible: false,
  isExportModalVisible: false,
  isDeleteModalVisible: false,
  isDeleteLettrageModalVisible: false,
  isLettrageModalVisible: false,
  isMarkAsViewModalVisible: false,
  isReverseModalVisible: false,
  isTransfertDeCompteACompteVisible: false,
  isReaffecterModalVisible: false,
  isActionLoading: false,
  accountId: undefined as number | undefined,
  selectedTransactionInfo: null as {
    ecritureIndex: number;
    transactionIndex: number;
  } | null,
};

/**
 * @french
 * Type dérivé de l’état initial.
 */
export type TransactionsState = typeof transactionsInitialState;
